import { groupChunksByFileType } from './utils';
import { UIDLUtils } from '@teleporthq/teleport-shared';
export default class AssemblyLine {
    constructor(plugins = []) {
        this.plugins = plugins;
    }
    async run(uidl, options, initialStructure = {
        uidl,
        options,
        chunks: [],
        dependencies: {},
    }) {
        var _a, _b;
        const structure = initialStructure;
        const finalStructure = await this.plugins.reduce(async (previousPluginOperation, plugin) => {
            const modifiedStructure = await previousPluginOperation;
            return plugin(modifiedStructure);
        }, Promise.resolve(structure));
        const externalDependencies = {
            ...UIDLUtils.extractExternalDependencies(((_a = finalStructure) === null || _a === void 0 ? void 0 : _a.dependencies) || {}),
            ...UIDLUtils.extractExternalDependencies(((_b = finalStructure.uidl) === null || _b === void 0 ? void 0 : _b.peerDefinitions) || {}),
        };
        const chunks = groupChunksByFileType(finalStructure.chunks);
        return {
            chunks,
            externalDependencies,
        };
    }
    getPlugins() {
        return this.plugins;
    }
    addPlugin(plugin) {
        this.plugins.push(plugin);
    }
}
//# sourceMappingURL=index.js.map